import { Button } from "@/components/ui/button";
import { VERSION_STRING } from "../config/version";

const AccessDenied = ({ user, onLogout }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 flex items-center justify-center">
      <div className="max-w-2xl mx-auto text-center px-8">
        <img
          src="/logo.png"
          alt="Logo"
          className="mx-auto mb-12 max-w-md w-full"
        />
        
        <div className="bg-neutral-800 border border-neutral-700 rounded-lg p-8 mb-8">
          <div className="text-6xl mb-4">🔒</div>
          <h1
            className="text-4xl font-bold text-white mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Accès non autorisé
          </h1>
          <p className="text-lg text-neutral-300 mb-6">
            Votre compte ({user?.email}) n'a pas encore été activé.
          </p>
          <p className="text-neutral-400 mb-8">
            Veuillez contacter votre administrateur pour obtenir l'accès au tableau de bord MSP.
          </p>
          
          <div className="bg-blue-900 bg-opacity-20 border border-blue-700 rounded-lg p-4 text-sm text-neutral-300 mb-6">
            <p className="font-semibold mb-2">Informations du compte:</p>
            <p>Nom: {user?.name}</p>
            <p>Email: {user?.email}</p>
          </div>
        </div>

        <Button
          onClick={onLogout}
          variant="outline"
          className="border-neutral-700 text-white hover:bg-neutral-800"
        >
          Se déconnecter
        </Button>
        
        <p className="text-xs text-neutral-500 mt-8">
          Version {process.env.REACT_APP_VERSION || VERSION_STRING} © Dominic Dussault
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;
